import { render } from "./ImageAnnotationInput.vue?vue&type=template&id=0ec4be13&scoped=true"
import script from "./ImageAnnotationInput.vue?vue&type=script&lang=js"
export * from "./ImageAnnotationInput.vue?vue&type=script&lang=js"

import "./ImageAnnotationInput.vue?vue&type=style&index=0&id=0ec4be13&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec4be13"]])

export default __exports__